import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

const useStyles = makeStyles({
  message: {
    textAlign: 'center',
    paddingTop: '15%',
  },
  messageWithPrerequisites: {
    textAlign: 'center',
    padding: '20px 0',
  },
});

const Message = ({ message, preRequisiteStatus }) => {
  const classes = useStyles();

  return (
    message && (
      <Typography
        variant="title2"
        className={
          preRequisiteStatus === 'Not Complete' ? classes.messageWithPrerequisites : classes.message
        }
      >
        {message}
      </Typography>
    )
  );
};

export default Message;
